import Vue from 'vue';
import { EventBus } from 'utils/event-bus';
import Cookie from 'js-cookie';
import {
  LOGOUT,
  CHECK_AUTHENTICATION,
  LOGIN,
  REFRESH_TOKEN,
} from 'store/mutation-types';

import { makeRequest } from 'utils/requestLogger';

const setToken = (token) => {
  Vue.$http.defaults.headers.common.Authorization = `Bearer ${token}`;
};

export default {
  [CHECK_AUTHENTICATION](state) {
    // social auth sets token in the cookie
    const cookie = Cookie.get('_prly_tk');
    const token = localStorage.getItem('_prly_tk') || cookie;
    if (token) {
      setToken(token);
      state.authenticated = true;
    }
    state.checked = true;
  },

  [REFRESH_TOKEN](state, token) {
    localStorage.setItem('_prly_tk', token);
    setToken(token);
  },

  [LOGIN](state, token) {
    localStorage.setItem('_prly_tk', token);
    setToken(token);
    EventBus.$emit('initialize-app');
    state.authenticated = true;
    Vue.router.push('/');
  },

  [LOGOUT](state) {
    localStorage.removeItem('_prly_tk');
    sessionStorage.removeItem('admin_integrations_school_id');
    Vue.$http.defaults.headers.common.Authorization = null;
    state.authenticated = false;

    makeRequest('post', '/acc/logout/', null, true)
      .then(() => {
        setTimeout(() => {
          EventBus.$emit('toast-msg', 'You have been sucessfully logged out.');
        }, 500);
      })
      .catch((error) => {
        console.log(error);
      });
  },
};



// WEBPACK FOOTER //
// ./src/app/features/authentication/authentication.mutations.js